var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1629282265916,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 14271,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8 755l58.9-26.5v-64L49.8 691zM960 287l-192 90.4v-54L256 130v469.2L174.3 635v64l81.8-35.8V716l512 193.7V441.4L960 351v-64zM704 821.4L320 676.2v-41.5l201-89.2v-64l-201 89.2V218.2l384 145v458.2z",
    "p-id": 14272
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxis);
export default __webpack_public_path__ + "static/media/axis.3a0744b13ad51ab0e5427d69e00a7346.svg";
export { ForwardRef as ReactComponent };